import { pdfjs } from 'react-pdf'

import type { PdfProcessingResult } from './types'

const PDF_MAX_EXTRACTED_CHARACTERS = 10_000_000
const PDF_PAGE_DELIMITER_PREFIX = '=== PAGE '
const PDF_PAGE_DELIMITER_SUFFIX = ' ==='

export const preprocessPdf = async (file: File): Promise<PdfProcessingResult> => {
    const arrayBuffer = await file.arrayBuffer()

    const loadingTask = pdfjs.getDocument({
        data: arrayBuffer,
        useSystemFonts: true,
    })

    try {
        const pdfDocument = await loadingTask.promise
        const pageTexts: string[] = []

        for (let pageNumber = 1; pageNumber <= pdfDocument.numPages; pageNumber += 1) {
            const page = await pdfDocument.getPage(pageNumber)
            const textContent = await page.getTextContent()
            const pageText = textContent.items.map((item) => ('str' in item ? item.str : '')).join(' ')

            pageTexts.push(pageText)

            page.cleanup()
        }

        const mergedText = pageTexts
            .map((text, index) => {
                return `${PDF_PAGE_DELIMITER_PREFIX}${index + 1}${PDF_PAGE_DELIMITER_SUFFIX}\n${text}`
            })
            .join('\n\n')

        const truncated = mergedText.slice(0, PDF_MAX_EXTRACTED_CHARACTERS)

        return {
            text: truncated,
            pageCount: pdfDocument.numPages,
            pageTexts,
        }
    } finally {
        void loadingTask.destroy()
    }
}
